import type { RouteRecordRaw } from 'vue-router';

export const newsRoutes: Array<RouteRecordRaw> = [
  {
    path: '/news',
    name: 'news',
    redirect: '/news/list',
    component: () => import('pages/info/news/McNews.vue'),
    meta: {
      title: 'News - Articles Publication',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'newsList',
        component: () => import('pages/info/news/NewsList.vue'),
        meta: {
          title: 'News List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'newsDetail',
        component: () => import('pages/info/news/NewsDetail.vue'),
        meta: {
          title: 'News Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'newsNew',
        component: () => import('pages/info/news/NewsNew.vue'),
        meta: {
          title: 'New News',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'newsExplorer',
        component: () => import('pages/info/news/NewsExplorer.vue'),
        meta: {
          title: 'News Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/users/news',
    name: 'userNews',
    redirect: '/users/news/explorer',
    component: () => import('pages/info/users/news/UserNews.vue'),
    meta: {
      title: 'News - Articles Publication',
      requiresAuth: true,
    },
    children: [
      {
        path: 'explorer',
        name: 'userNewsExplorer',
        component: () => import('pages/info/users/news/NewsExplorer.vue'),
        meta: {
          title: 'News Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
